import {Component, Input, OnInit} from '@angular/core';
import {CustomerResourceService} from '../../services/database/resource/customer-resource.service';
import {DocumentModel} from '../../models/document.model';
import {LoadingController, ModalController} from '@ionic/angular';
import {GeneralService} from '../../services/general.service';

@Component({
    selector: 'app-orders-for-customer',
    templateUrl: './orders-for-customer.page.html',
    styleUrls: ['./orders-for-customer.page.scss'],
})
export class OrdersForCustomerPage implements OnInit {

    @Input() document: DocumentModel;
    @Input() type: string;
    @Input() ordersList: any;
    @Input() contractList: any;
    queryText = '';
    loading: any;

    constructor(private customerRes: CustomerResourceService,
                private modalController: ModalController,
                private loadingController: LoadingController,
                private generalServices: GeneralService) {
    }

    async ngOnInit() {
        this.loadingFetchingDocs();
    }

    fetchDocuments(event) {
        this.refreshDocuments().then(() => {
            event.target.complete();
        });
    }

    selectDocument(ord: DocumentModel) {
        this.document.parentDocument = ord;
        console.log(this.document.parentDocument);
        if (ord.site) {
            if (ord.site.name) {
                this.document.site = ord.site;
            }
        }
        if (ord.contact) {
            if (ord.contact.name) {
                this.document.contact = ord.contact;
            }
        }
        for (const line of ord.detailLines) {
            line.overrideDescriptionNote = line.description;
        }
        this.modalController.dismiss();
    }

    cancelOrder() {
        this.modalController.dismiss();
    }

    async loadingFetchingDocs() {
        this.loadingController.create({
            message: 'Please wait...',
            translucent: true,
            cssClass: 'custom-class custom-loading'
        }).then((overlay) => {
            this.loading = overlay;
            this.loading.present();
        });
        try {
            await this.refreshDocuments().then(() => {
                this.loading.dismiss();
            });
        } catch (e) {
            this.generalServices.createToast('No connection with the server');
        } finally {
            this.loading.dismiss();
        }
    }

    async refreshDocuments() {
        this.ordersList = await this.customerRes.getOrdersByCustomer(this.document.customer);
        this.contractList = await this.customerRes.getContracts(this.document.customer.id);
        this.ordersList.sort((a, b) => (a.documentNumber < b.documentNumber) ? 1 : -1);
        console.log(this.ordersList);
    }
}
